"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function Hero() {
  return <section id="hero" data-nav="light" className="relative w-full border-b border-border bg-background text-foreground overflow-hidden">
      {/* Structural Datum Ruler / Grid Lines */}
      <div className="absolute inset-0 pointer-events-none z-0">
        <div className="h-full max-w-7xl mx-auto border-x border-border/40 grid grid-cols-2 md:grid-cols-4">
          <div className="border-r border-border/30 h-full"></div>
          <div className="border-r border-border/30 h-full hidden md:block"></div>
          <div className="border-r border-border/30 h-full hidden md:block"></div>
          <div className="h-full"></div>
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 pt-14 pb-16 md:pt-20 md:pb-24">
        {/* Metal Rating Plate Frame / Eyebrow Band */}
        <div className="flex flex-wrap items-center justify-between gap-4 border-b border-border pb-4 mb-8">
          <div className="inline-flex items-center gap-2">
            <span className="h-2 w-2 bg-primary"></span>
            <span className="font-mono text-xs md:text-sm uppercase tracking-widest text-muted-foreground font-medium">
              PARTS • COMPONENTS • REPLACEMENT EQUIPMENT
            </span>
          </div>
        </div>

        {/* Hero Content (Single Column Reflow) */}
        <div className="max-w-4xl flex flex-col justify-center">
          <h1 className="font-serif uppercase font-bold text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-wide text-foreground leading-none mb-6">
            Mechanical Bull Parts &amp; Accessories
          </h1>

          <p className="font-sans text-base sm:text-lg text-foreground/90 leading-relaxed mb-8 max-w-3xl">
            Finding the right mechanical bull part starts with identifying the system you already own. Controllers, control boxes, inflatables, blowers and other replacement components can look similar while using different connections, dimensions or specifications. Mechanical Bull Shop brings available parts together with clear product information so you can compare what is in stock and confirm compatibility before making an enquiry.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 font-serif uppercase tracking-wider text-base font-semibold px-6 py-6 shadow-xs">
              <Link to="#product-catalog">
                BROWSE AVAILABLE PARTS
                <ArrowRight className="size-4 ml-2" />
              </Link>
            </Button>

            <Button asChild variant="outline" className="border-foreground text-foreground hover:bg-foreground hover:text-background font-serif uppercase tracking-wider text-base font-semibold px-6 py-6 transition-colors duration-150">
              <Link to="/ContactPage">
                ASK ABOUT COMPATIBILITY
              </Link>
            </Button>
          </div>
        </div>

        {/* Footnote Bar with Direct Contact Indicator */}
        <div className="mt-12 pt-4 border-t border-border flex flex-col sm:flex-row items-start sm:items-center justify-between text-xs text-muted-foreground gap-3">
          <div className="font-mono">
            DIRECT PARTS LINE: <a href="tel:4197686305" className="text-foreground font-semibold hover:underline">419 768-6305</a> | TECHNICAL EMAIL: <a href="mailto:sales@mechanicalbullshop.com" className="text-foreground font-semibold hover:underline">sales@mechanicalbullshop.com</a>
          </div>
          <div className="font-mono uppercase text-[11px] text-muted-foreground/80">
            HOURS: MON-FRI 8AM - 6PM EST
          </div>
        </div>
      </div>
    </section>;
}